import React from 'react';
import GuideLineScreen from './guide-line-screen';

export default class GuideLine extends React.Component<any, {}> {
    render(){
        const { steps, isClickable, currentStep} = this.props;
        return(
            <GuideLineScreen steps={steps} isClickable={isClickable} currentStep={currentStep}/>
        )
    }
}